import { userHasSignupBusinessData } from './businessProfile';
import { getSubscriptionAccessMode } from './subscriptionAccess';

export { getSubscriptionAccessMode, isSubscriptionReadOnly, formatGraceEndsAt, getSubscriptionStatusPresentation, mustRegularizeSubscription } from './subscriptionAccess';

/** Bloqueo total de la app privada (redirect a /planes). */
export function needsSubscriptionPayment(user) {
  if (!user) return false;
  if (user.isSuperAdmin === true && user.subscription?.smokeTest !== true) return false;
  return getSubscriptionAccessMode(user) === 'blocked';
}

/** Enlaces de navbar cuando la cuenta está bloqueada (solo regularización y cuenta). */
export const SUBSCRIPTION_BLOCKED_NAV_LINKS = [
  { key: 'planes', label: 'Regularizar pago', to: '/planes?pago=pendiente' },
  { key: 'ayuda', label: 'Ayuda', to: '/ayuda' },
];

export function getSubscriptionBlockedNavLinks() {
  return SUBSCRIPTION_BLOCKED_NAV_LINKS;
}

export const PAYMENT_COMPLETION_PATHS = [
  '/planes',
  '/cuenta',
  '/pago/resultado',
  '/login',
  '/register',
  '/completar-perfil',
  '/terminos',
  '/privacidad',
  '/ayuda',
  '/contacto',
];

export function isPaymentCompletionPath(pathname) {
  const path = String(pathname || '').split('?')[0];
  return PAYMENT_COMPLETION_PATHS.some(
    (allowed) => path === allowed || path.startsWith(`${allowed}/`)
  );
}

/** Invitados logueados: falta plan o datos de negocio antes de entrar a la app. */
export function guestNeedsOnboarding(user) {
  if (!user) return true;
  const plan = user.currentPlan;
  const hasBusinessProfile = userHasSignupBusinessData(user);
  const profileIncomplete = user.subscription?.profileCompleted === false;
  return (
    !plan
    || (typeof plan === 'object' && !plan.id && !plan._id)
    || (profileIncomplete && !hasBusinessProfile)
  );
}
